<div class="modal-content">
  <div class="modal-header">
    <h4
      class="title is-size-4"
      translate="credentialsModal.title"
      [translateParams]="titleParams"
    ></h4>
  </div>
  <div class="modal-body">
    <p
      class="has-text-grey mb-4"
      translate="credentialsModal.subtitle"
      [translateParams]="titleParams"
    ></p>

    <div [formGroup]="form" novalidate>
      <fino-input
        formControlName="link"
        label="credentialsModal.link"
        class="field"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>

      <fino-input
        formControlName="username"
        label="credentialsModal.username"
        class="field"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>

      <fino-input
        formControlName="password"
        label="credentialsModal.password"
        class="field"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>
    </div>
  </div>
  <div class="modal-footer">
    <div right class="mt-4 is-flex is-centered">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        (click)="open()"
        fino-button
        label="credentialsModal.submit"
        [labelParams]="titleParams"
      ></button>

      <button
        type="button"
        class="ml-1"
        (click)="abort()"
        fino-button
        label="credentialsModal.abort"
      ></button>
    </div>
  </div>
</div>
